import { AdminAccount } from '@/api/generated'
import { OfferLite } from '@/business/offers/models/offer-lite'
import { OrganisationLite } from '@/business/organisation/interfaces/organisation-lite'

export interface AdministrationState {
  accounts: AdminAccount[]
  impersonatingToken?: string
  offers: OfferLite[]
  organisations: OrganisationLite[]
}

export const EmptyAdministrationState: AdministrationState = {
  accounts: [],
  impersonatingToken: undefined,
  offers: [],
  organisations: [],
}
